import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';

import { getEnvironmentVariable } from '@spacefill/shared/src/utils/GetEnvVar';
import { Button } from '@spacefill/uikit/src/components/Button';
import { NotFound } from '@spacefill/uikit/src/components/NotFound';
import { safeLocalStorage } from '@spacefill/uikit/src/utils/storage';

export function getLocalStorageData() {
    const localStorageData = {};
    for (let i = 0; i < safeLocalStorage.length; i++) {
        const key = safeLocalStorage.key(i);
        localStorageData[key] = safeLocalStorage.getItem(key);
    }
    return localStorageData;
}

export const ErrorComponent = () => {
    const error = useRouteError();
    const { t } = useTranslation();
    const externalConsoleServiceUrl = getEnvironmentVariable('externalConsoleServiceUrl');

    return (
        <div className='h-full overflow-auto'>
            <NotFound
                errorCode=''
                errorMessage={t('An error occurred')}
                details={
                    <pre className='p-4 my-2 font-["Courier"] leading-5 bg-violet-100 rounded-md whitespace-pre-wrap'>
                        {error.message + '\n' + error.stack}
                    </pre>
                }
                cta={
                    <Button onClick={() => (window.location.href = externalConsoleServiceUrl)}>
                        {t('Return to the home page')}
                    </Button>
                }
            />
        </div>
    );
};
